import { createApp } from 'vue'
import '@/style/normalize.css'
import router from './router'
import App from './App.vue'

const app = createApp(App)
app.use(router).mount('#app')

// document.addEventListener('DOMContentLoaded', function () {
//   const enableList = ['test', 'development']
//   if (enableList.includes(process.env.VUE_APP_TITLE)) {
//     // 创建一个 <script> 元素
//     var scriptElement = document.createElement('script')
//     // 使用 attribute 语法设置脚本文件的 URL
//     scriptElement.setAttribute('src', 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js')
//     // 将 <script> 元素添加到 <body> 的末尾
//     document.body.appendChild(scriptElement)
//     scriptElement.onload = function () {
//       new window.VConsole()
//     }
//   }
// })
